import type { AcpClientOptions } from '../clients/acp-client.js';
import type { AcpBridgeHooksOptions } from './acp-bridge-types.js';
import { errorMessage } from '../../../error-message.js';
import { getSessionFileChangeDirectoryFlags } from '../session-file-change-path-kind.js';
import { removeSymbolIndexForFile, updateSymbolIndexForFile } from '../../../code-nav/index.js';

export function createBridgeOnFileChange(opts: AcpBridgeHooksOptions): NonNullable<AcpClientOptions['onFileChange']> {
  const { resolveRouting, getSendSessionUpdate, log, sessionParentPath } = opts;

  return (evt) => {
    const routing = resolveRouting();
    const runId = routing?.runId;
    const sessionId = routing?.sessionId;
    const send = getSendSessionUpdate();
    if (!send || !runId || !sessionId) {
      log(
        `[Bridge service] File change not forwarded (${evt.path}): session or run not wired to the bridge.`,
      );
      return;
    }
    const dirFlags = getSessionFileChangeDirectoryFlags(sessionParentPath, evt.path);
    try {
      send({
        type: 'session_file_change',
        sessionId,
        runId,
        path: evt.path,
        oldText: evt.oldText,
        newText: evt.newText,
        patchContent: evt.patchContent,
        isDirectory: dirFlags.isDirectory,
        directoryRemoved: dirFlags.directoryRemoved,
      });
    } catch (err) {
      log(`[Bridge service] Session file change failed for ${evt.path}: ${errorMessage(err)}`);
    }

    if (dirFlags.directoryRemoved) {
      void removeSymbolIndexForFile(sessionParentPath, evt.path).catch((err) => {
        log(`[code-nav] Symbol index remove failed for ${evt.path}: ${errorMessage(err)}`);
      });
      return;
    }
    if (!dirFlags.isDirectory) {
      void updateSymbolIndexForFile(sessionParentPath, evt.path).catch((err) => {
        log(`[code-nav] Symbol index update failed for ${evt.path}: ${errorMessage(err)}`);
      });
    }
  };
}
